import Mustache from 'lib/mustache';
import Pagination from 'mypage/pagination';
import 'mypage/event';

const $loadMoreButton = $('button#load_more');
const template = $('#row_template').html();
const $searchInput = $('#mypage_list_filter_input');
const $listBody = $('.event__teams ol');

function generateNewEntries (Mustache, template) {
  return function (data) {
    const html = data.reduce(function (a, b) {
      return a + Mustache.render(template, b);
    }, '');

    return html;
  };
}

function loadedCount (selector) {
  return function () {
    const rows = $(selector).find('> li');
    return rows.length;
  };
}

let lastQuery = '';
function searchQuery (rowsSelector) {
  return function (data = '') {
    const $rows = $(rowsSelector);
    const previousQuery = lastQuery;
    lastQuery = data;

    // New query
    if (data !== previousQuery && data === '') { return {}; }
    if ($rows.length <= 0) { return { name_query: data }; }
    if (data !== previousQuery) { return { name_query: data }; }

    const offset = $rows.length;

    // Continue last query
    return {
      name_query: data,
      offset
    };
  };
}

let entryGeneratorFunc;

if (template.length) {
  entryGeneratorFunc = generateNewEntries(Mustache, template);
}

const url = `/events/mypage/${window.ajaxBaseData.id}/${window.ajaxBaseData.year}/teams.json`;

if ($loadMoreButton.length && template.length) {
  const moreDataQueryFunc = searchQuery('.event__teams ol li');
  const loadedCountFunc = loadedCount('.event__teams ol');

  Pagination.loadMore($loadMoreButton, $searchInput, url, moreDataQueryFunc, entryGeneratorFunc, loadedCountFunc);
}

if ($searchInput.length && $listBody.length && template.length) {
  const queryFunc = searchQuery('.event__teams ol li');

  Pagination.searchField($searchInput, $loadMoreButton, $listBody, url, queryFunc, entryGeneratorFunc);
}
